import React, { Component, useState } from 'react';
import Frame from '../images/Frame.svg';
import ContactPopup from './Popup';

function Decision() {
  const [isOpen, setIsOpen] = useState(false);
  const openPopup = ()=>{
    setIsOpen(true)
  }
  const updateBoollen = (value)=>{
    setIsOpen(value)
  }
  return (
      <div className='md:pt-20'>
          <div className='pt-30 py-8'>
              <div className='max-w-[1024px] mx-auto bg-sandle-dark-bg px-4 grid grid-cols-1 md:grid-cols-2 gap-4 pb-3'>
                <div className="p-8">
                  <h2 className='text-green text-4xl font-bold'>Start one today!</h2>
                  <p className='text-base text-bodyText py-5'>People everywhere are empowered to start campaigns, mobilize supporters, and work with Decision Makers to drive solutions.</p>
                  <button className='mt-2 rounded bg-green-bg text-t-14 text-white py-2 px-7 items-center' onClick={()=>openPopup()}>Contact us</button>
                </div>
                <div className="mt-[-70px] p-4">
                      <img 
                          src= {Frame} 
                          alt="Frame" 
                          className="max-w-sm float-right" 
                      />
                </div>
              </div>
          </div>
        <ContactPopup popup={isOpen} updateValue={(value)=>updateBoollen(value)}/>
      </div>
  )
}

export default Decision;